var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-toolbar',{attrs:{"flat":""}},[_c('v-icon',[_vm._v("person")]),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('auth.logout')))]),_c('v-spacer')],1),_c('v-card-text',[_c('h2',[_vm._v(_vm._s(_vm.$t('auth.loggingOut')))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }